import React from 'react';
import { PhotoIcon } from '@heroicons/react/24/outline';
import { transactionImageUrl } from '../utils/transactionPhoto';

const TransactionProofImage = ({ path, label = 'Proof' }) => {
  const url = transactionImageUrl(path);

  if (!url) {
    return <span className="text-xs font-medium text-slate-400">No image</span>;
  }

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center gap-2 rounded-lg border border-slate-200 bg-white px-2 py-1 text-xs font-semibold text-slate-700 shadow-sm hover:border-indigo-300 hover:text-indigo-700"
      title="Open proof image"
    >
      <img src={url} alt={label} className="h-9 w-9 rounded-md object-cover" loading="lazy" />
      <span className="hidden sm:inline">{label}</span>
      <PhotoIcon className="h-4 w-4 sm:hidden" />
    </a>
  );
};

export default TransactionProofImage;
